// DESIGN-SPEC §5.10 PageHeader 二级页头
"use client";

import { ArrowLeft } from "lucide-react";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { cn } from "@/lib/cn";

export function PageHeader({
  title,
  rightAction,
  fallbackHref = "/",
  className,
}: {
  title: string;
  rightAction?: ReactNode;
  fallbackHref?: string;
  className?: string;
}) {
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 0);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  const goBack = () => {
    if (window.history.length > 1) router.back();
    else router.push(fallbackHref);
  };

  return (
    <header
      className={cn(
        "page-header sticky top-0 z-40 flex min-h-14 items-center justify-between border-b border-transparent bg-paper/92 px-1 backdrop-blur-xl",
        scrolled && "border-line/80 shadow-[0_8px_24px_rgba(42,35,22,0.06)]",
        className,
      )}
    >
      <button
        type="button"
        onClick={goBack}
        aria-label="返回"
        className="flex size-11 shrink-0 items-center justify-center text-ink focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-forest-500"
      >
        <ArrowLeft className="size-5 stroke-[1.5]" aria-hidden="true" />
      </button>
      <h1 className="pointer-events-none min-w-0 flex-1 px-2 py-3 text-center font-display text-[17px] leading-6 font-semibold tracking-[0.02em] text-ink">
        {title}
      </h1>
      <div className="flex min-h-11 min-w-11 items-center justify-center">
        {rightAction}
      </div>
    </header>
  );
}
